module.exports = __webpack_public_path__ + "media/A8.58b08494.wav";